import React from 'react';
import { Box, IconButton, Menu, MenuItem, Typography } from '@/ui';

interface RouteItem { key: string; label: string }

interface InnerNavMobileProps {
  routes: Array<RouteItem>;
  selectedKey: string;
  onSelect: (key: string) => void;
  menuAnchor: HTMLElement | null;
  onOpenMenu: (event: React.MouseEvent<HTMLElement>) => void;
  onCloseMenu: () => void;
  onSelectFromMenu: (key: string) => void;
}

const InnerNavMobile: React.FC<InnerNavMobileProps> = ({
  routes,
  selectedKey,
  onSelect,
  menuAnchor,
  onOpenMenu,
  onCloseMenu,
  onSelectFromMenu,
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'flex-start', 
      gap: 1.5,
      width: '100%',
      minWidth: 0
    }}>
      <IconButton
        onClick={onOpenMenu}
        sx={{
          p: 0.5,
          mt: 0.25,
          flexShrink: 0,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
          }
        }}
      >
        <Typography variant="h6" sx={{ fontSize: '20px', lineHeight: '24px', color: 'text.primary' }}>☰</Typography>
      </IconButton>

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={onCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {routes.map((route) => (
          <MenuItem
            key={route.key}
            onClick={() => onSelectFromMenu(route.key)}
            selected={selectedKey === route.key}
          >
            {route.label}
          </MenuItem>
        ))}
      </Menu>

      <Box sx={{
        display: 'flex',
        gap: 1.5,
        flexWrap: 'nowrap',
        overflowX: 'auto',
        flex: 1,
        minWidth: 0,
        // Smooth momentum scrolling on iOS
        WebkitOverflowScrolling: 'touch',
        // Hide scrollbar while keeping scroll functionality
        scrollbarWidth: 'none', // Firefox
        msOverflowStyle: 'none', // IE and Edge
        '&::-webkit-scrollbar': {
          display: 'none' // Chrome, Safari, Opera
        }
      }}>
        {routes.map((route) => (
          <Box
            key={route.key}
            onClick={() => onSelect(route.key)}
            sx={{
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              gap: 0.5,
              py: 0.5,
              flexShrink: 0,
              // Touch feedback for mobile
              transition: 'transform 0.1s ease',
              '&:active': {
                transform: 'scale(0.96)',
              },
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: selectedKey === route.key ? 'text.primary' : '#616161',
                fontSize: '16px',
                whiteSpace: 'nowrap',
                fontWeight: 400,
                lineHeight: '24px',
                // Smooth transition for selection state
                transition: 'color 0.15s ease',
                '&:hover': {
                  color: 'text.primary',
                },
              }}
            >
              {route.label}
            </Typography>
            <Box sx={{
              height: '2px',
              backgroundColor: selectedKey === route.key ? 'text.primary' : 'transparent',
              width: '100%',
              borderRadius: '1px',
              // Smooth underline transition
              transition: 'background-color 0.15s ease',
            }} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default InnerNavMobile;


